class ExpandingNavigation extends HTMLElement {
  constructor() {
    super();
    this.setupClickListeners();
  }

  toggleExpansion(target) {
    const isExpanded = target.getAttribute('aria-expanded') === 'true';
    target.setAttribute('aria-expanded', String(!isExpanded));

    const controlledElement = document.getElementById(target.getAttribute('aria-controls'));
    if (controlledElement) {
      controlledElement.classList.toggle('grid-rows-[0fr]', isExpanded);
      controlledElement.classList.toggle('grid-rows-[1fr]', !isExpanded);
      controlledElement.querySelectorAll('a').forEach((el) => {
        el.setAttribute('tabindex', isExpanded ? '-1' : '0');
      });
    }
  }

  closeExpandedBranches(except) {
    [...this.querySelectorAll('button[top-level][aria-expanded="true"]')]
      .filter((button) => !button.closest('li').contains(except))
      .forEach((button) => this.toggleExpansion(button));
  }

  setupClickListeners() {
    this.addEventListener('click', (ev) => {
      if (ev.target.matches('button')) {
        ev.preventDefault();
        this.closeExpandedBranches(ev.target);
        this.toggleExpansion(ev.target);
      }
    });
  }
}

customElements.define('expanding-navigation', ExpandingNavigation);
